import StoreTotalCell from './StoreTotalCell'

export default StoreTotalCell
